<template>
	<div class="app">
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: 'App',
	components: {},
	mounted() {
		
	}
};
</script>
<style lang="scss">
@import './assets/sass/base.scss';
</style>
